<div class="mode-control">
  <div class="row h-100 align-content-center justify-content-between">
    @for (item of this.datas; track item) {
      <div
        class="col-auto mode-control-button pointer-hover"
        [class.mode-control-button-select]="value === item.ref"
        (click)="onButtonClick(item)"
      >
        <div class="row h-100 align-content-center">
          <div
            [class]="
              'col text-center ' +
              (value === item.ref ? item.color : 'color-medium')
            "
          >
            <div class="mode-control-button-icon">
              <i [class]="item.icon"></i>
            </div>
            <div class="mode-control-button-text fw-bold text-uppercase fs-14">
              {{ item.label }}
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
